import React, { useState, useEffect } from "react";
import "./ExamScheduleResource.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const ExamScheduleResource = () => {
  const [activeTab, setActiveTab] = useState("Autonomy");
  const [filters, setFilters] = useState({
    semester: null,
    examType: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10; // Increased to 10 rows per page

const allData = {
    Autonomy: [
      {
        id: 12,
        name: "Sem I Mid Semester Examination Practical Schedule",
        semester: "Sem I",
        examType: "Mid Semester Examination",
        pdf: "/pdf/exam/sem 1 MSE Practical schedule.pdf",
      },
      {
        id: 11,
        name: "Sem IV ATKT End Semester Examination Schedule",
        semester: "Sem IV",
        examType: "End Semester Examination",
        pdf: "/pdf/exam/14 Sem 4 ATKT ESE Schedule.pdf",
      },
      {
        id: 10,
        name: "Sem II ATKT End Semester Examination Schedule",
        semester: "Sem II",
        examType: "End Semester Examination",
        pdf: "/pdf/exam/13 Sem 2 ATKT ESE Schedule.pdf",
      },
      {
        id: 9,
        name: "Sem III ATKT ISA Schedule",
        semester: "Sem III",
        examType: "ISA Schedule",
        pdf: "/pdf/exam/12 Sem 3 ATKT ISA Schedule.pdf",
      },
      {
        id: 8,
        name: "Sem III ATKT End Semester Examination Schedule",
        semester: "Sem III",
        examType: "End Semester Examination",
        pdf: "/pdf/exam/11 Sem 3 ATKT ESE Schedule.pdf",
      },
      {
        id: 7,
        name: "Sem III Regular End Semester Examination Schedule",
        semester: "Sem III",
        examType: "End Semester Examination",
        pdf: "/pdf/exam/10 Sem 3 Regular ESE Schedule.pdf",
      },
      {
        id: 6,
        name: "IMCA Sem III ORPR Schedule",
        semester: "Sem III",
        examType: "ORPR Schedule",
        pdf: "/pdf/exam/9 IMCA Sem 3 ORPR Schedule.pdf",
      },
      {
        id: 1,
        name: "Sem I Continuous Assessment 1 Notice",
        semester: "Sem I",
        examType: "Continuous Assessment",
        pdf: "/pdf/exam/Sem 1 CA1-Notice.pdf",
      },
      {
        id: 2,
        name: "Sem I Mid Semester Examination Theory Schedule",
        semester: "Sem I",
        examType: "Mid Semester Examination",
        pdf: "/pdf/exam/Sem 1 MSE Theory.pdf",
      },
      {
        id: 3,
        name: "Sem I End Semester Examination Time Table",
        semester: "Sem I",
        examType: "End Semester Examination",
        pdf: "/pdf/exam/sem 1 ESE.pdf",
      },
      {
        id: 4,
        name: "Sem III Continuous Assessment 1 & 2 Notice",
        semester: "Sem III",
        examType: "Continuous Assessment",
        pdf: "/pdf/exam/Sem 3 CA1-CA2 Notice.pdf",
      },
      {
        id: 5,
        name: "Sem III Mid Semester Examination Theory & Practical Schedule",
        semester: "Sem III",
        examType: "Mid Semester Examination",
        pdf: "/pdf/exam/Sem 3 MSE theory practical schedule.pdf",
      }
    ],
    University: []
  };

  const filteredData = allData[activeTab].filter((item) => {
    const matchesSearch = item.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesSemester = !filters.semester || item.semester === filters.semester;
    const matchesExamType = !filters.examType || item.examType === filters.examType;
    return matchesSearch && matchesSemester && matchesExamType;
  });

  // reset to page 1 whenever filters/search/tab change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, filters, searchTerm]);

  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));

  const currentData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleViewPDF = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };

  const clearFilters = () => {
    setFilters({ semester: null, examType: null });
    setSearchTerm("");
  };

  return (
    <>
      <Navbar />
      <PageHeader
        title="Exam Schedule"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Exam Schedule" },
        ]}
      />
      <div className="exam-esrc-page-root">
        <div className="exam-esrc-container">
          <div className="exam-esrc-inner">
            {/* Toggle buttons */}
            <div className="exam-esrc-toggle-row">
              <button
                className={
                  activeTab === "Autonomy"
                    ? "exam-esrc-toggle-btn-active"
                    : "exam-esrc-toggle-btn"
                }
                onClick={() => {
                  setActiveTab("Autonomy");
                  clearFilters();
                }}
              >
                Autonomy
              </button>
              <button
                className={
                  activeTab === "University"
                    ? "exam-esrc-toggle-btn-active"
                    : "exam-esrc-toggle-btn"
                }
                onClick={() => {
                  setActiveTab("University");
                  clearFilters();
                }}
              >
                University
              </button>
            </div>

            {/* Table */}
            <div className="exam-esrc-table-wrapper">
              <table className="exam-esrc-table">
                <thead>
                  <tr className="exam-esrc-thead-row">
                    <th className="exam-esrc-th">Document Name</th>
                    <th className="exam-esrc-th">Semester</th>
                    <th className="exam-esrc-th">Exam Type</th>
                    <th className="exam-esrc-th exam-esrc-text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item) => (
                      <tr key={item.id} className="exam-esrc-row">
                        <td className="exam-esrc-td">
                          <div className="exam-esrc-doc-cell">
                            <span className="exam-esrc-icon-wrapper">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="exam-esrc-svg-icon"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm0 2l4 4h-4V4zM8 14h8v2H8v-2zm0-4h5v2H8v-2z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            <span className="exam-esrc-doc-title">{item.name}</span>
                          </div>
                        </td>
                        <td className="exam-esrc-td">
                          <span className="exam-esrc-badge">{item.semester}</span>
                        </td>
                        <td className="exam-esrc-td">
                          <span className="exam-esrc-badge">{item.examType}</span>
                        </td>
                        <td className="exam-esrc-td exam-esrc-text-right">
                          <button
                            className="exam-esrc-view-btn"
                            onClick={() => handleViewPDF(item.pdf)}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        className="exam-esrc-td"
                        style={{ textAlign: "center", padding: "40px" }}
                      >
                        No results found. Try adjusting your filters.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {currentData.length > 0 && totalPages > 1 && (
              <div className="exam-esrc-pagination">
                {Array.from({ length: totalPages }, (_, idx) => {
                  const page = idx + 1;
                  return (
                    <button
                      key={page}
                      className={
                        currentPage === page
                          ? "exam-esrc-page-btn-active"
                          : "exam-esrc-page-btn"
                      }
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                <span className="exam-esrc-pagination-dots">...</span>

                <button
                  className="exam-esrc-next-btn"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                >
                  <span>Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="exam-esrc-svg-icon-small"
                    viewBox="0 0 24 24"
                  >
                    <path d="M10 17l5-5-5-5v10z" fill="currentColor" />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExamScheduleResource;